<template>
  <v-dialog v-model="dialog" width="950" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-card
        class="d-flex align-center justify-center"
        v-bind="attrs"
        v-on="on"
        width="113"
        height="100"
        min-width="113"
        tile
      >
        <v-icon>mdi-plus-circle-outline</v-icon>
      </v-card>
    </template>
    <EventCreateModal v-if="dialog" @close="dialog = false" />
  </v-dialog>
</template>

<script>
import EventCreateModal from './EventCreateModal'

export default {
  name: 'EventCreateButton',

  components: {
    EventCreateModal
  },

  data: () => ({
    dialog: false
  })
}
</script>
